var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYamlDropdownSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1693 4.66667H5.83594C5.3757 4.66667 5.0026 5.03977 5.0026 5.5V15.5C5.0026 15.9602 5.3757 16.3333 5.83594 16.3333H14.1693C14.6295 16.3333 15.0026 15.9602 15.0026 15.5V5.5C15.0026 5.03977 14.6295 4.66667 14.1693 4.66667ZM5.83594 3C4.45523 3 3.33594 4.11929 3.33594 5.5V15.5C3.33594 16.8807 4.45523 18 5.83594 18H14.1693C15.55 18 16.6693 16.8807 16.6693 15.5V5.5C16.6693 4.11929 15.55 3 14.1693 3H5.83594Z",
    fill: "#4D99EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 6.33301H13.3307V7.99967H6.66406V6.33301Z",
    fill: "#4D99EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 9.66699H13.3307V11.3337H6.66406V9.66699Z",
    fill: "#4D99EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 13H10.8307V14.6667H6.66406V13Z",
    fill: "#4D99EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYamlDropdownSelected);
export default __webpack_public_path__ + "static/media/yamlDropdownSelected.26286d625d04a01fdaed370a24741296.svg";
export { ForwardRef as ReactComponent };